<template>
	<div class="comments">
		<comment-form :user="user" :serial="serial" @need-update="update"></comment-form>

		<div class="empty" v-if="comments.length == 0 && !loader">Еще никто не оставлял свой комментарий.</div>

		<div class="header" v-if="comments.length > 0">Комментарии:</div>

		<div class="center" v-if="loader">
			<i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
		</div>

		<div class="comment" v-for="comment in comments">
			<img src="/images/avatar.png" alt="" class="avatar">
			<div class="content">
				<div class="name">{{comment.user_name}}<span>#{{comment.user_id}}</span></div>
				<div class="message" v-html="comment.message"></div>
				<div class="info">Добавлено: {{comment.created_at}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import CommentForm from './CommentForm.vue'

	export default {
		components: {
			'comment-form': CommentForm
		},

		props: ['user', 'serial'],

		data: function () {
			return {
				loader: false,
				comments: [],
			}
		},

		mounted: function () {
			this.update();
		},

		methods: {
			update: function () {
				var request = $.ajax('/api/v1/serial/'+this.serial+'/comments', {
					'method': 'get',
					'dataType': 'json'
				});

				this.loader = true;

				request.then(function (data) {
					if (data.status === 'ok') {
						this.comments = data.result;
					} else if (data.status === 'error') {
						alert('Произошла ошибка.');
					}

					this.loader = false;
				}.bind(this));
			}
		}
	}
</script>
